import React from "react";
import { useHistory } from "react-router";
import { usePrimaryOrganizationId, useTabs } from "../../hooks";
import { useSelfOrganizationUser } from "../../hooks/useOrganization";
import { TabOptions } from "../../components/Tabs";

type Tabs = "settings" | "users" | "templates" | "inbox" | "billing";

const TAB_OPTIONS: TabOptions<Tabs> = [
  { label: "Organization", value: "settings" },
  { label: "Users", value: "users" },
  { label: "Billing", value: "billing" },
];

export const SettingsTabs = ({ current = "settings" }: { current?: Tabs }) => {
  const history = useHistory<Tabs>();
  const orgId = usePrimaryOrganizationId();
  const currentOrgUser = useSelfOrganizationUser();
  let tabOptions = TAB_OPTIONS.filter(
    (t) => currentOrgUser?.role === "ADMIN" || t.value !== "users",
  );
  const [, tabs] = useTabs(tabOptions, current, null, (newVal) => {
    let path = newVal === "settings" ? "" : newVal;
    history.push(`/organization/${orgId}/settings/${path}`.replace(/\/$/, ""));
  });

  return <div className="mt-md">{tabs}</div>;
};
